import { render, staticRenderFns } from "./MessageLikes.vue?vue&type=template&id=b0eda01e&"
import script from "./MessageLikes.vue?vue&type=script&lang=js&"
export * from "./MessageLikes.vue?vue&type=script&lang=js&"
import style0 from "./MessageLikes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports